

import React, { useEffect, useState, useMemo } from "react";
import {
  useReactTable,
  createColumnHelper,
  getCoreRowModel,
  getSortedRowModel,
  // getFilteredRowModel,
  flexRender,
} from "@tanstack/react-table";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { convertToSlug } from "../../utils/helps";
import { useParams, useSearchParams } from "react-router-dom";
import { fetchPartners } from "../../features/admin/PartnerSlice";
import ApiCustom from "../../utils/ApiCustom";
import { HomeIcon } from "@heroicons/react/24/outline";

const PublicMembershipDisplay = () => {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const { partners, status, error } = useSelector((state) => state.partners);
  const searchFromUrl = searchParams.get("search") || "";
  const [searchQuery, setSearchQuery] = useState(
    searchFromUrl || slug || localStorage.getItem("searchQuery") || ""
  );
  const [filteredData, setFilteredData] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const userId = localStorage.getItem("userId");
  const loading = status === "loading";

  useEffect(() => {
    const nextSearchQuery = searchFromUrl || slug || "";
    setSearchQuery(nextSearchQuery);
    localStorage.setItem("searchQuery", nextSearchQuery);
  }, [slug, searchFromUrl]);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchPartners());
    }
  }, [dispatch, status]);

  useEffect(() => {
    if (
      partners?.filter((member) => member.approvalStatus === "Đã duyệt") &&
      partners?.filter((member) => member.approvalStatus === "Đã duyệt")
        .length > 0
    ) {
      if (!searchQuery) {
        setFilteredData(
          partners?.filter((member) => member.approvalStatus === "Đã duyệt")
        );
      } else {
        const filtered = partners
          ?.filter((member) => member.approvalStatus === "Đã duyệt")
          .filter(
            (member) =>
              convertToSlug(member.companyName)?.includes(
                convertToSlug(searchQuery)
              ) ||
              convertToSlug(member.userFullName)?.includes(
                convertToSlug(searchQuery)
              )
            // member.userFullName?.toLowerCase().includes(searchQuery.toLowerCase())
          );
        setFilteredData(filtered);

        if (
          slug &&
          filtered?.length === 1 &&
          convertToSlug(filtered[0]?.companyName) === convertToSlug(slug)
        ) {
          setExpandedRows({ 0: true });
        }
      }
    }
  }, [partners, searchQuery, slug]);

  const toggleRowExpand = (rowId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  const columnHelper = createColumnHelper();

  const columns = useMemo(
    () => [
      {
        header: "STT",
        accessorKey: "index",
        cell: ({ row }) => row.index + 1,
      },
      columnHelper.accessor("userAvatar", {
        header: "Logo",
        cell: (info) => {
          const avatar = info.getValue();
          return avatar ? (
            <img
              src={avatar}
              alt="Company Logo"
              className="w-10 h-10 object-cover rounded-full"
              loading="lazy"
            />
          ) : (
            <div className="w-10 h-10 bg-gray-200 flex items-center justify-center text-gray-400 rounded-full">
              No img
            </div>
          );
        },
      }),
      columnHelper.accessor("companyName", {
        header: "Tên doanh nghiệp",
        cell: (info) => info.getValue(),
      }),
      columnHelper.accessor("taxCode", {
        header: "Mã số thuế",
        cell: (info) => (info.getValue() !== "null" ? info.getValue() : ""),
      }),
      columnHelper.accessor("userPhone", {
        header: "Số điện thoại",
        cell: (info) => info.getValue(),
      }),
      columnHelper.accessor("businessFields", {
        header: "Lĩnh vực",
        cell: (info) => {
          return (
            <ul className="list-disc list-inside">
              {(info.getValue() || []).map((field, idx) => (
                <li key={idx}>{field.name}</li>
              ))}
            </ul>
          );
        },
      }),
      {
        header: "",
        id: "expander",
        cell: ({ row }) => (
          <button
            onClick={() => toggleRowExpand(row.id)}
            className="text-blue-500 hover:text-blue-700 focus:outline-none"
          >
            {expandedRows[row.id] ? (
              <span>▲ Thu gọn</span>
            ) : (
              <span>▼ Xem thêm</span>
            )}
          </button>
        ),
      },
    ],
    [columnHelper, expandedRows]
  );

  const table = useReactTable({
    data: filteredData,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    localStorage.setItem("searchQuery", e.target.value);
  };

  const renderExpandedRow = (row) => {
    const rowData = row.original;
    return (
      <tr className="bg-gray-50">
        <td colSpan={columns.length} className="px-6 py-3">
          <div className="grid grid-cols-2 gap-4 p-3">
            <div>
              <h3 className="font-semibold text-gray-700">
                Thông tin chi tiết
              </h3>
              <div className="mt-2 grid grid-cols-1 gap-2">
                <div>
                  <span className="font-medium">Người đại diện:</span>{" "}
                  {rowData.userFullName || "Chưa cập nhật"}
                </div>
                <div>
                  <span className="font-medium">Chức vụ:</span>{" "}
                  {rowData.position || "Chưa cập nhật"}
                </div>
                <div>
                  <span className="font-medium">Địa chỉ:</span>{" "}
                  {rowData.businessAddress || "Chưa cập nhật"}
                </div>
                <div>
                  <span className="font-medium">Email:</span>{" "}
                  {rowData.userEmail || "Chưa cập nhật"}
                </div>
                <div>
                  <span className="font-medium">Hotline:</span>{" "}
                  {rowData.hotline || "Chưa cập nhật"}
                </div>
                <div>
                  <span className="font-medium">Website:</span>{" "}
                  <Link to={rowData.websiteOrHotline || "#"} target="_blank">
                    {rowData.websiteOrHotline || "Chưa cập nhật"}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    );
  };

  const handleExportExcel = async () => {
    try {
      const response = await ApiCustom("/company-export-excel", {
        responseType: "blob",
      });

      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "danh_sach_hoi_vien.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Lỗi khi tải file Excel:", error);
    }
  };

  return (
    <div className="container mx-auto">
      <nav className="flex text-gray-500 text-sm mb-4" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-2">
          <li className="inline-flex items-center">
            <Link to="/" className="inline-flex items-center hover:text-blue-600 font-medium">
              <HomeIcon className="w-4 h-4 mr-2 text-gray-400" />
              Trang chủ
            </Link>
          </li>
          <li>
            <div className="flex items-center">
              <svg className="w-3 h-3 mx-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M7.05 4.05a.75.75 0 011.06 0l5.25 5.25a.75.75 0 010 1.06l-5.25 5.25a.75.75 0 11-1.06-1.06L11.19 10 7.05 5.91a.75.75 0 010-1.06z" />
              </svg>
              <span className="ml-1 text-gray-400 font-medium">Danh sách hội viên</span>
            </div>
          </li>
        </ol>
      </nav>
      <div className="p-4">
        <div className="mb-4 flex justify-between">
          <div className="relative flex items-center">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <svg
                className="w-4 h-4 text-gray-500"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                />
              </svg>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={handleSearchChange}
              className="block p-2 pl-10 text-sm input input-bordered input-sm"
              placeholder="Tìm kiếm hội viên"
            />
          </div>
          <button
            className="px-2 py-1 btn btn-outline btn-success text-sm"
            onClick={handleExportExcel}
            disabled={userId == null}
          >
            Xuất Excel
          </button>
        </div>

        {loading ? (
          <div className="text-center py-4">Đang tải dữ liệu...</div>
        ) : error ? (
          <div className="text-center py-4 text-red-500">
            Có lỗi xảy ra: {error}
          </div>
        ) : (
          <>
            <div className="overflow-x-auto rounded-lg shadow">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-base-200">
                  {table.getHeaderGroups().map((headerGroup) => (
                    <tr key={headerGroup.id}>
                      {headerGroup.headers.map((header) => (
                        <th
                          key={header.id}
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                          onClick={header.column.getToggleSortingHandler()}
                        >
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                          {{
                            asc: " 🔼",
                            desc: " 🔽",
                          }[header.column.getIsSorted()] ?? null}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody className="bg-base-100 divide-y divide-gray-200">
                  {table.getRowModel().rows.length > 0 ? (
                    table.getRowModel().rows.map((row) => (
                      <React.Fragment key={row.id}>
                        <tr className="hover:bg-gray-50">
                          {row.getVisibleCells().map((cell) => (
                            <td
                              key={cell.id}
                              className="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                            >
                              {flexRender(
                                cell.column.columnDef.cell,
                                cell.getContext()
                              )}
                            </td>
                          ))}
                        </tr>
                        {expandedRows[row.id] && renderExpandedRow(row)}
                      </React.Fragment>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={columns.length}
                        className="px-6 py-4 text-center text-sm text-gray-500"
                      >
                        Không tìm thấy hội viên nào phù hợp
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="mt-4">
              <p className="text-sm text-gray-500">
                Hiển thị {filteredData.length} hội viên
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PublicMembershipDisplay;

